import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import FCRow from "../../components/flashcards/FCRow";

const axios = require("axios").default;

function ViewSet() {
  const [error, setError] = useState("");
  const [noFC, setNFC] = useState("");
  const [flashcards, setFlashcards] = useState([]);
  const [nameCap, setNameCap] = useState("");
  const navigate = useNavigate();
  let params = useParams();

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/sets/${params.setname}`,
        {
          token,
        }
      )
      .then(function (response) {
        if (response.data.length === 0) {
          setError("Set not found within database");
        } else if (response.data[0].flashcards.length === 0) {
          setNFC("There's no flashcards within this set");
        } else {
          setFlashcards(response.data[0].flashcards);

          setNameCap(
            response.data[0].setName.charAt(0).toUpperCase() +
              response.data[0].setName.slice(1)
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <>
      <div className="bg-zinc-800 text-slate-200 py-2 px-32 flex justify-between md:px-12">
        <p className="text-xl font-semibold py-2">{nameCap}</p>
        <button
          className="text-white bg-green-400 border-grey-100 rounded p-2"
          onClick={() => {
            navigate(`/dashboard/set/${params.setname}/addcard`);
          }}
        >
          Add Card
        </button>
      </div>

      {noFC ? (
        <div className="rounded-lg border-solid border border-slate-200 my-2 w-4/12 shadow-md p-2 mx-auto mt-16 p-5">
          <p>You currently have no flashcards within this set.</p>
        </div>
      ) : (
        <div
          style={{ height: "32rem" }}
          className="overflow-auto rounded-lg border-solid border border-slate-300 w-10/12 shadow-md p-2 mx-auto mt-8 md:w-11/12"
        >
          <div className="flex ml-2">
            <p className="w-5/12 font-semibold">Question</p>
            <p className="w-5/12 font-semibold ml-5">Answer</p>
          </div>
          {flashcards.map((e, i) => {
            return (
              <FCRow
                setName={params.setname}
                nameCap={nameCap}
                title={e.title}
                description={e.description}
                id={e.id}
                key={e.id}
              ></FCRow>
            );
          })}
        </div>
      )}
    </>
  );
}

export default ViewSet;
